import { serviceMaker } from "..";
import { IActiveInactive, IPagination } from "../../data/AppInterface";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import { paginationParams, toQueryString } from "../../utils/QueryString";

export interface ISubscriptionPackageFilter {
  visibility_type: string | null;
  has_desktop: string | null;
  is_active: string | null;
}

interface IPackageDuplicatePayload {
  name: string;
  visibility_type: string;
  has_desktop: boolean;
}

export interface IPackageConfigurationPayload {
  config_key: string;
  config_value: string | null;
}

interface IPackageFeaturePayload {
  feature_id: string;
  annotation: string | null;
}

export interface ISubscriptionPackagePayload {
  name: string;
  description: string | null;
  visibility_type: string;
  has_desktop: boolean;
  validity: number;
  base_price: number;
  cgst: number;
  sgst: number;
  igst: number;
  configurations: IPackageConfigurationPayload[];
  features: IPackageFeaturePayload[];
  claim_ids: string[];
}

export const GET_ALL_SUBSCRIPTION_PACKAGE = (
  pagination: IPagination,
  search: string,
  filter: ISubscriptionPackageFilter
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_subscription_package.url +
      toQueryString({ ...paginationParams(pagination), search, ...filter }),
    API_ENDPOINTS.get_all_subscription_package.method
  );

export const GET_SUBSCRIPTION_PACKAGE_DUPLICATE_SOURCES = () =>
  serviceMaker(
    API_ENDPOINTS.get_subscription_package_duplicate_sources.url,
    API_ENDPOINTS.get_subscription_package_duplicate_sources.method
  );

export const GET_SUBSCRIPTION_PACKAGE_DETAIL = (id: string) =>
  serviceMaker(
    API_ENDPOINTS.get_subscription_package_detail.url(id),
    API_ENDPOINTS.get_subscription_package_detail.method
  );

export const DUPLICATE_SUBSCRIPTION_PACKAGE = (
  id: string,
  payload: IPackageDuplicatePayload
) =>
  serviceMaker(
    API_ENDPOINTS.duplicate_subscription_package.url(id),
    API_ENDPOINTS.duplicate_subscription_package.method,
    payload
  );

export const UPDATE_SUBSCRIPTION_PACKAGE = (
  id: string,
  payload: ISubscriptionPackagePayload
) =>
  serviceMaker(
    API_ENDPOINTS.update_subscription_package.url(id),
    API_ENDPOINTS.update_subscription_package.method,
    payload
  );

export const ACTIVE_INACTIVE_SUBSCRIPTION_PACKAGE = (
  id: string,
  value: IActiveInactive
) =>
  serviceMaker(
    API_ENDPOINTS.active_inactive_subscription_package.url(id),
    API_ENDPOINTS.active_inactive_subscription_package.method,
    value
  );

export const DELETE_SUBSCRIPTION_PACKAGE = (id: string) =>
  serviceMaker(
    API_ENDPOINTS.delete_subscription_package.url(id),
    API_ENDPOINTS.delete_subscription_package.method
  );
